import React from "react";
import styles from "./OurStory.module.scss";

const OurStory = () => {
  return (
    <div className={styles.featureSection}>
      <div className={styles.textContainer}>
        <h1 className={styles.title}>Our Story</h1>
        <p className={styles.description}>Welcome to Sealkloud*</p>
        <p className={styles.description}>
          At Sealkloud, we specialize in consulting and delivery of all SAP
          solutions, leveraging the founder's extensive expertise in solutioning
          and architecture to our clients. Our founders have held leadership
          roles providing enterprise digital solutions across various industries
          including Retail, AFS, Fashion, Manufacturing, B2B, and B2C eCommerce.
        </p>
        <p className={styles.description}>
          With a deep understanding of industry challenges and innovative SAP
          solutions, Sealkloud aims to be your trusted partner in achieving
          seamless integration and superior performance.
        </p>
      </div>
      <div className={styles.imageContainer}>
        <img
          src="/assests/solutions/sap-4-hana.jpg"
          alt="Hot Air Balloons"
          className={styles.image}
        />
      </div>
    </div>
  );
};

export default OurStory;
